var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('router-link',{staticClass:"campaign-top-banner",attrs:{"to":_vm.campaignPath,"aria-label":"双十一充值钜惠，查看活动"}},[_c('img',{attrs:{"src":require("@/assets/images/header/banner.gif"),"alt":"双十一充值钜惠"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }